import { render, staticRenderFns } from "./WastedShots.vue?vue&type=template&id=7ad4c6f3"
import script from "./WastedShots.vue?vue&type=script&lang=js"
export * from "./WastedShots.vue?vue&type=script&lang=js"
import style0 from "./WastedShots.vue?vue&type=style&index=0&id=7ad4c6f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports